import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { addCommon as addCommonProjections } from 'ol/proj';


declare var $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    constructor(
        public translate: TranslateService
    ) {
        //translate.setDefaultLang('it-IT');
    }

    ngOnInit() {
        addCommonProjections();

        const params = new URLSearchParams(window.location.search);
        if (params.has('cuaaSelezionato')) {
            sessionStorage.setItem('cuaaSelezionato', params.get('cuaaSelezionato'));
        }

    }
}
